import { nanoid } from "nanoid";
import { TWordsInputInitialValue } from "./WordsInputList.types";

export const getWordsInputInitialValue = (): TWordsInputInitialValue => ({
  id: nanoid(),
  content: "",
  hint: "",
});
